import React from 'react';
import {
  Box,
  Link,
  LinkWrapper,
  MoreResourcesWrapper,
  Span,
} from './MoreResources.style';

interface IMoreResources {
  isLargeScreen: boolean;
}

const MoreResources: React.FC<IMoreResources> = ({ isLargeScreen }) => {
  return (
    <MoreResourcesWrapper isLargeScreen={isLargeScreen}>
      <Box isLargeScreen>
        <Span>MORE RESOURCES</Span>
      </Box>
      <Box>
        <LinkWrapper>
          <Link href="/glossary/general-information/about-opus">
            About Opus
          </Link>
        </LinkWrapper>
      </Box>
      <Box>
        <LinkWrapper>
          <Link href="/systemStatus">Opus System Status</Link>
          <Link
            href="https://warnermusicgroup.freshservice.com/support/catalog/items/117"
            target="_blank"
          >
            Get Opus Access
          </Link>
        </LinkWrapper>
      </Box>
    </MoreResourcesWrapper>
  );
};

export default MoreResources;
